import { render, staticRenderFns } from "./AssessmentSingleTaskModal.vue?vue&type=template&id=59c3f00b&"
import script from "./AssessmentSingleTaskModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentSingleTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports